import { Form, message, Upload } from 'antd';
import React from 'react';
import { CardButton } from '../../../Card';
import styles from './Attachments.module.scss';
import { maxFileSize } from '../../../../constants/maxFileSize';
import { useSetTsAttachments } from '../../model';
import AttachmentsList from '../AttachmentsList/AttachmentsList';

export const documentsAllowedExtensions = [
  'jpg',
  'pdf',
  'doc',
  'docx',
  'jpeg',
  'png',
  'raw',
  'tiff',
  'bmp',
];

const beforeUpload = (file) => {
  const fileExtension = file.name.split('.').pop().toLowerCase();

  if (!documentsAllowedExtensions.includes(fileExtension)) {
    message.error(`Файл ${file.name} имеет недопустимый формат.`);
    return false;
  }

  if (file.size > maxFileSize) {
    message.error(`Файл ${file.name} весит больше 15 мб.`);
    return false;
  }

  return true;
};

const Attachments = () => {
  const { addFile } = useSetTsAttachments();

  return (
    <Form.Item
      label="Документы ТС"
      style={{ flex: 1, margin: 0, alignSelf: 'start' }}
    >
      <Upload.Dragger
        className={styles.upload}
        multiple
        beforeUpload={beforeUpload}
        customRequest={addFile}
        showUploadList={false}
      >
        <CardButton 
          className={styles.btn} 
          text="Добавить документ" 
        />
      </Upload.Dragger>
      <AttachmentsList />
    </Form.Item>
  );
};

export default Attachments;
